package amazon.lastmile.inject

import app.nestbridge.feature.invitations.ui.InvitationQrScanUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = InvitationQrScanUiFactory::class)
public interface AppNestbridgeFeatureInvitationsUiInvitationQrScanUiFactory {
  @Provides
  @IntoSet
  public fun provideInvitationQrScanUiFactoryFactoryMultibinding(invitationQrScanUiFactory: InvitationQrScanUiFactory): Ui.Factory = invitationQrScanUiFactory
}
